import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type TrackTagUpdated } from '../types';

export const useTrackNewTagCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackNewTagCreated = useCallback(
    (params: TrackTagUpdated) => {
      track(`New tag created`, params);
    },
    [track],
  );

  return { trackNewTagCreated };
};
